/**
 * Placeholder Pages
 * Temporary placeholder components for routes not yet implemented
 */

import {
  AlertTriangle,
  BarChart3,
  FileText,
  Package,
  Settings,
  Shield,
  Store,
  UserCheck,
  Users,
} from 'lucide-react';
import React from 'react';

interface PlaceholderPageProps {
  title: string;
  description: string;
  icon: React.ReactNode;
}

const PlaceholderPage: React.FC<PlaceholderPageProps> = ({
  title,
  description,
  icon,
}) => (
  <div className="flex flex-col items-center justify-center h-64 text-center">
    <div className="w-16 h-16 rounded-xl bg-pos-primary/10 flex items-center justify-center mb-4">
      {icon}
    </div>
    <h2 className="text-xl font-semibold text-gray-900 mb-2">{title}</h2>
    <p className="text-gray-500 max-w-md">{description}</p>
    <div className="mt-6 flex items-center gap-2 text-amber-600 bg-amber-50 px-4 py-2 rounded-lg">
      <AlertTriangle size={18} />
      <span className="text-sm font-medium">Coming Soon</span>
    </div>
  </div>
);

export const MenuPage: React.FC = () => (
  <PlaceholderPage
    title="Menu Items"
    description="Create and manage your menu items, categories, and pricing. This feature is currently under development."
    icon={<FileText size={32} className="text-pos-primary" />}
  />
);

export const OutletsPage: React.FC = () => (
  <PlaceholderPage
    title="Outlets"
    description="Manage multiple outlet locations, their settings, and configurations."
    icon={<Store size={32} className="text-pos-primary" />}
  />
);

export const UsersPage: React.FC = () => (
  <PlaceholderPage
    title="Users"
    description="Manage team members, assign roles, and control access permissions."
    icon={<Users size={32} className="text-pos-primary" />}
  />
);

export const RolesPage: React.FC = () => (
  <PlaceholderPage
    title="Roles & Permissions"
    description="Define custom roles and set granular permissions for your team."
    icon={<UserCheck size={32} className="text-pos-primary" />}
  />
);

export const SalesReportsPage: React.FC = () => (
  <PlaceholderPage
    title="Sales Reports"
    description="View detailed sales analytics, trends, and performance metrics."
    icon={<BarChart3 size={32} className="text-pos-primary" />}
  />
);

export const InventoryReportsPage: React.FC = () => (
  <PlaceholderPage
    title="Inventory Reports"
    description="Track stock levels, movement history, and inventory valuations."
    icon={<Package size={32} className="text-pos-primary" />}
  />
);

export const SecurityPage: React.FC = () => (
  <PlaceholderPage
    title="Security"
    description="Configure security settings, audit logs, and access controls."
    icon={<Shield size={32} className="text-pos-primary" />}
  />
);

export const SettingsPage: React.FC = () => (
  <PlaceholderPage
    title="Settings"
    description="Customize your POS system, preferences, and integrations."
    icon={<Settings size={32} className="text-pos-primary" />}
  />
);
